import React from 'react';
import { ScrollReveal } from '../components/ScrollReveal';
import { CTAButton } from '../components/CTAButton';
import { ShieldCheck } from 'lucide-react';
import { handleCheckoutRedirect } from '../App';
export function ClosingSection() {
  return <section className="bg-transparent relative z-10 py-12 px-6" data-id="element-69">
      <ScrollReveal className="max-w-4xl mx-auto flex flex-col items-center text-center" data-id="element-70">
        <h2 className="font-playfair text-gold text-5xl md:text-6xl font-bold leading-tight mb-10 text-glow-gold" data-id="element-71">
          Tonight Could Be
          <br data-id="element-72" />
          the Night Everything Shifts.
        </h2>

        <div className="text-lunar-white text-xl md:text-2xl leading-[1.8] font-lato space-y-4 mb-16" data-id="element-73">
          <p data-id="element-74">You've waited long enough.</p>
          <p data-id="element-75">You've done the work.</p>
          <p data-id="element-76">You've stayed hopeful.</p>
          <p data-id="element-77">You've tried.</p>
          <p className="font-bold text-2xl pt-4" data-id="element-78">
            Now try the one thing you haven't done yet:
          </p>
          <p className="text-violet font-bold text-3xl text-glow-violet italic" data-id="element-79">
            Let your sleeping mind do the work for you.
          </p>
        </div>

        <div className="w-full max-w-2xl mx-auto flex flex-col items-center" data-id="element-80">
          <CTAButton size="large" className="mb-6 w-full" onClick={() => handleCheckoutRedirect('https://pay.hotmart.com/W104946771H?checkoutMode=10')} data-id="element-81">
            🌙 GET THE MIDNIGHT MAGNET — $6.37 NOW
          </CTAButton>

          <div className="bg-green-900/20 border border-green-500/30 rounded-lg p-4 w-full mb-6" data-id="element-82">
            <p className="text-green-400 text-sm font-semibold flex flex-wrap justify-center gap-x-4 gap-y-2" data-id="element-83">
              <span className="flex items-center" data-id="element-84">
                <ShieldCheck className="w-4 h-4 mr-1" data-id="element-85" /> Bank-Level Security
              </span>
              <span className="hidden md:inline text-green-500/50" data-id="element-86">·</span>
              <span data-id="element-87">Instant Digital Download</span>
              <span className="hidden md:inline text-green-500/50" data-id="element-88">·</span>
              <span data-id="element-89">Access in 60 Seconds</span>
              <span className="hidden md:inline text-green-500/50" data-id="element-90">·</span>
              <span data-id="element-91">7-Day Money Back Guarantee</span>
            </p>
          </div>

          <p className="text-gold font-semibold text-lg" data-id="element-92">
            Join 4,800+ women who chose themselves tonight.
          </p>
        </div>
      </ScrollReveal>
    </section>;
}